// import React, { useEffect, useState } from "react";
// import Chart from "react-apexcharts";
// import dummyData from "../data.json"; // Import JSON directly

// const LightScheduleChart = () => {
//   const [lightData, setLightData] = useState([]);

//   useEffect(() => {
//     setLightData(dummyData.lightData); // Set data from JSON
//   }, []);

//   // Convert time (HH:MM) to minutes
//   const timeToMinutes = (time) => {
//     if (!time) return 0;
//     const [hours, minutes] = time.split(":").map(Number);
//     return hours * 60 + minutes;
//   };

//   // Convert minutes back to time format (HH:MM)
//   const minutesToTime = (minutes) => {
//     const hours = Math.floor(minutes / 60);
//     const mins = minutes % 60;
//     return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
//   };

//   // Prepare Dumbbell Chart data
//   const series = lightData.map((zone, index) => ({
//     name: zone.zone,
//     data: zone.timings.map(({ start, end }) => ({
//       x: zone.zone, // X-axis is the zone name
//       y: [timeToMinutes(start), timeToMinutes(end)], // Y-axis is [start, end] time in minutes
//     })),
//     color: ["#FFD700", "#FFA500", "#FFEC8B", "#FFCC00", "#FFFF00"][index % 5], // Bright yellow-orange colors
//   }));

//   // Chart options
//   const options = {
//     chart: {
//       type: "rangeBar",
//       height: 400,
//       toolbar: {
//         show: false, // Hide toolbar
//       },
//     },
//     plotOptions: {
//       bar: {
//         horizontal: true,
//         rangeBarGroupRows: true,
//         borderRadius: 7,
//         barHeight: "60%",
//       },
//     },
//     xaxis: {
//       type: "numeric",
//       min: 0, // Start at 00:00
//       max: 1440, // End at 24:00
//       tickAmount: 24, // Show hourly intervals
//       labels: {
//         formatter: (value) => minutesToTime(value),
//       },
//       title: { text: "Time (24-hour format)" },
//     },
//     yaxis: { title: { text: "Zones" } },
//     legend: {
//       position: "top", // Move legend to top
//       horizontalAlign: "center",
//     },
//     tooltip: {
//       custom: function ({ seriesIndex, dataPointIndex, w }) {
//         const data = w.config.series[seriesIndex].data[dataPointIndex];
//         const startTime = minutesToTime(data.y[0]);
//         const endTime = minutesToTime(data.y[1]);

//         return `
//           <div class="apexcharts-tooltip-title" style="font-weight: bold; margin-bottom: 5px; text-align: center;">
//             ${data.x}
//           </div>
//           <div style="padding: 5px 10px;">
//             <span>${startTime} - ${endTime}</span>
//           </div>
//         `;
//       },
//     },
//   };

//   return (
//     <div>
//       <Chart options={options} series={series} type="rangeBar" height={400} />
//     </div>
//   );
// };

// export default LightScheduleChart;

import { getLightOnOffData } from 'api';
import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';

// import { useSelector } from "react-redux";

const LightScheduleChart = () => {
  const [lightData, setLightData] = useState([]);
  // const selectedDate = useSelector((state) => state.date.selectedDate); // Get selected date from Redux
  const date = useSelector((state) => state.customization.currentDate);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  const formattedDate = formatDate(date);
  // const selectedDate = "2025-03-11"

  // Convert time (HH:MM) to total minutes from midnight
  const timeToMinutes = (time) => {
    if (!time) return 0;
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  // Convert minutes back to time format (HH:MM)
  const minutesToTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
  };

  // Generate an analogous color based on index
  const generateAnalogousGreen = (index) => {
    const baseHue = 120; // Base green hue
    const hueShift = (index * 5) % 15; // Shift hue slightly within 115-135° range
    return `hsl(${baseHue + hueShift}, 90%, 45%)`; // High saturation & slightly darker brightness for vibrant green
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!formattedDate) return;

        const requestData = { date: formattedDate, source_id: 'dombivli' };
        const response = await getLightOnOffData(requestData);

        if (response?.data?.data) {
          const apiData = response.data.data[0]?.lightData || [];
          setLightData(apiData);
        }
      } catch (error) {
        console.error('Error fetching light schedule data:', error);
      }
    };

    fetchData();
  }, [formattedDate]);

  // Prepare Dumbbell Chart data
  const series = lightData.map((zone, index) => ({
    name: zone.zone,
    data: zone.timings.map(({ start, end }) => ({
      x: zone.zone, // X-axis is the zone name
      y: [timeToMinutes(start), timeToMinutes(end)] // Y-axis is [start, end] time in minutes
    })),
    color: generateAnalogousGreen(index) // Assign analogous colors dynamically
  }));

  // Chart options
  const options = {
    chart: {
      type: 'rangeBar',
      height: 400,
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        rangeBarGroupRows: true,
        borderRadius: 7,
        barHeight: '60%'
      }
    },
    xaxis: {
      type: 'numeric',
      min: 0,
      max: 1440,
      tickAmount: 24,
      labels: { formatter: (value) => minutesToTime(value) },
      title: { text: 'Time (24-hour format)' }
    },
    yaxis: { title: { text: 'Zones' } },
    legend: {
      position: 'top',
      horizontalAlign: 'center'
    },
    tooltip: {
      custom: function ({ seriesIndex, dataPointIndex, w }) {
        const data = w.config.series[seriesIndex].data[dataPointIndex];
        return `
          <div class="apexcharts-tooltip-title" style="font-weight: bold; text-align: center;">
            ${data.x}
          </div>
          <div style="padding: 5px 10px;">
            <span>${minutesToTime(data.y[0])} - ${minutesToTime(data.y[1])}</span>
          </div>
        `;
      }
    }
  };

  return <Chart options={options} series={series} type="rangeBar" height={400} />;
};

export default LightScheduleChart;
